import React from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import { Link } from "gatsby"

import { useForm } from "react-hook-form"
import { toast } from "react-hot-toast"
import axios from "axios"
//#region styles
const ContributeSection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 120px 200px 80px 200px;
  h2 {
    font-family: Tinos;
    font-style: italic;
    font-weight: bold;
    font-size: 22px;
    line-height: 25px;
    color: #989085;
    margin-top: 30px;
    margin-bottom: 18px;
  }
  @media only screen and (max-width: 1100px) {
    padding-left: 100px;
    padding-right: 100px;
  }
  @media only screen and (max-width: 550px) {
    padding-left: 50px;
    padding-right: 50px;
  }
`

const ContributeHeader = styled.div`
  display: flex;
  flex-direction: column;
  h1 {
    font-family: "Amasis", serif;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 41px;
  }
  p {
    font-family: Cabin;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 174%;
  }
`

const ContributeGenre = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media only screen and (max-width: 960px) {
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
  }
  button {
    background: #f9f3ec;
    border: 1px solid #c6bcaf;
    box-sizing: border-box;
    width: 30vw;
    padding: 24px;
    &:not(:last-child) {
      margin-right: 20px;
    }
    text-align: left;

    &:active {
      box-shadow: 2px 2px 0px #310542;
    }
    @media only screen and (max-width: 960px) {
      margin-bottom: 20px;
      width: 100%;
    }
  }

  h1 {
    font-family: "Amasis", serif;
    font-style: normal;
    font-weight: bold;
    font-size: 26px;
    line-height: 33px;
    color: #3e3120;
    margin-bottom: 6px;
  }

  p {
    font-family: "Cabin", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 170%;
  }
`

const ContributeBodyWrapper = styled.div`
  margin-top: 48px;
`

const ContributeBody = styled(motion.div)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media only screen and (max-width: 960px) {
    flex-direction: column;
  }
`

const ContributeGuidelines = styled.div`
  display: flex;
  flex-direction: column;
  width: 25vw;
  margin-right: 64px;
  h1 {
    font-family: Tinos;
    font-style: italic;
    font-weight: bold;
    font-size: 22px;
    line-height: 25px;
    color: #989085;
    margin-bottom: 20px;
  }
  p {
    font-family: "Cabin", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 161.5%;
    color: #424242;
    margin-bottom: 20px;
  }

  a {
    font-family: Tinos;
    font-style: italic;
    font-weight: bold;
    font-size: 18px;
    color: #989085;
    @media only screen and (max-width: 960px) {
      margin-bottom: 24px;
    }
  }
  @media only screen and (max-width: 960px) {
    width: 100%;
  }
`

const ContributeSubmission = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  h1 {
    font-family: Tinos;
    font-style: italic;
    font-weight: bold;
    font-size: 22px;
    line-height: 25px;
    color: #989085;
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 960px) {
    width: 100%;
  }
`

const ContributeForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 21px 34px 20px 20px;
  background: #fffcf8;
  border: 1px solid #310542;
  box-shadow: 4px 4px 0px #310542;

  > button[type="submit"] {
    font-family: Cabin, sans-serif;
    font-size: 14px;
    padding: 8px 27px;
    color: #f9f6f3;
    border: 0;
    background-color: #310542;
    align-self: flex-end;
    @media only screen and (max-width: 960px) {
      margin-top: 12px;
    }
  }
`

const InputContainer = styled.div`
  display: flex;
  margin-bottom: 12px;

  > input,
  textarea {
    font-family: Cabin, sans-serif;
    padding: 8px 12px 8px 17px;
    border: 1px solid #eee6e3;
    background-color: #f9f6f3;
    color: #424242;

    ::placeholder {
      color: #c8baaa;
    }
  }
  > textarea {
    resize: none;
    height: 170px;
  }
  > * {
    flex: 1;
  }

  @media only screen and (max-width: 960px) {
    margin-bottom: 0px;
  }
`

const TwoInputColumn = styled(InputContainer)`
  > input:first-of-type {
    margin-right: 20px;
  }
  @media only screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
    > input:first-of-type {
      margin-right: 0px;
    }
    > input {
      margin-bottom: 12px;
    }
  }
`

const FileInput = styled(InputContainer)`
  display: flex;
  align-items: center;
  padding: 12px 24px;
  background-color: #f9f6f3;
  border: 1px solid #eee6e3;
  input[type="file"] {
    display: none;
  }

  label {
    font-size: 14px;
    color: #c8baaa;
    padding: 8px 27px;
    margin-right: 24px;
    background-color: #fcfcfc;
    border: 1px solid #c8baaa;
    cursor: pointer;
    @media only screen and (max-width: 960px) {
      padding: 8px 14px;
    }
  }

  > span {
    font-size: 14px;
    color: #c8baaa;
  }
  > * {
    flex: initial;
  }
`
//#endregion

const ENGLISH = "english"
const FILIPINO = "filipino"
const ARTWORK = "artwork"

type SelectFormArguments = typeof ENGLISH | typeof FILIPINO | typeof ARTWORK

const Contribute: React.FC<{ data: any }> = function ({ data }) {
  const [selected, setSelected] = React.useState(ENGLISH)



  // condensed into one function
  function setSelectedForm(form: SelectFormArguments) {
    setSelected(form)
  }

  const onFormSubmit = path => data => {

    const formData = new FormData()

    formData.append('name', data.name)
    formData.append('email', data.email)
    formData.append('course', data.course)
    formData.append('contact', data.contact)
    formData.append('bio', data.bio ? data.bio : 'No Bio')

    Array.prototype.forEach.call(data.files, function(file,i) { 
      formData.append(`file${i + 1}`, file)
    })
    toast.promise(
      axios.post(`https://heights-restructuring.herokuapp.com/${path}`, formData),
      {
        loading: "Sending response...",
        success: <b>Response sent!</b>,
        error: <b>Failed. Please try again.</b>,
      }
    )

    resetEnglish()
    resetFilipino()
    resetArtwork()
  }



  //english
  const { register: registerEnglish, handleSubmit: handleSubmitEnglish, reset: resetEnglish } = useForm()
  //filipino
  const { register: registerFilipino, handleSubmit: handleSubmitFilipino, reset: resetFilipino } = useForm()
  //artwork
  const { register: registerArtwork, handleSubmit: handleSubmitArtwork, reset: resetArtwork } = useForm()
  
  return (
    <ContributeSection>
      <ContributeHeader>
        <h1>Contribute to HEIGHTS!</h1>
        <p>
          {data.contributeDescription.contributeDescription}
        </p>
      </ContributeHeader>
      <h2>Select your Genre</h2>
      <ContributeGenre>
        <button onClick={() => setSelectedForm(ENGLISH)}>
          <h1>English Works</h1>
          {/* <p>
            FIlipino works are in line with our goal to discover new and
            fledgling talent, HEIGHTS organizes workshops for both writers and
            artists.
          </p> */}
        </button>
        <button onClick={() => setSelectedForm(FILIPINO)}>
          <h1>Filipino Works</h1>
          {/* <p>
            FIlipino works are in line with our goal to discover new and
            fledgling talent, HEIGHTS organizes workshops for both writers and
            artists.
          </p> */}
        </button>
        <button onClick={() => setSelectedForm(ARTWORK)}>
          <h1>Artworks</h1>
          {/* <p>
            FIlipino works are in line with our goal to discover new and
            fledgling talent, HEIGHTS organizes workshops for both writers and
            artists.
          </p> */}
        </button>
      </ContributeGenre>
      <ContributeBodyWrapper>
        {selected === ENGLISH ? (
          <ContributeBody
            key={ENGLISH}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 1 }}
          >
            <ContributeGuidelines>
              <h1>Submission Guidelines</h1>
              <p>{data.englishGuidelines.englishGuidelines}</p>
              <Link to={`/${data.englishArticle.slug}`}>Read More</Link>
            </ContributeGuidelines>
            <ContributeSubmission>
              <h1>Submission Form</h1>
              <ContributeForm onSubmit={handleSubmitEnglish(onFormSubmit('contribute-english'))}>
                <TwoInputColumn>
                  <input type="text" placeholder="Name*" ref={registerEnglish({required: true})} required name="name"></input>
                  <input
                    type="text"
                    placeholder="Course & Batch / Department / Office*"
                    ref={registerEnglish({required: true})}
                    required
                    name="course"
                  ></input>
                </TwoInputColumn>
                <TwoInputColumn>
                  <input type="email" placeholder="Email Address*" ref={registerEnglish({required: true})} required name="email"></input>
                  <input type="text" placeholder="Contact number*" ref={registerEnglish({required: true})} required name="contact"></input>
                </TwoInputColumn>
                <InputContainer>
                  <textarea placeholder="Author Bio / Bio-note, and Notes on Procedure (optional)" ref={registerEnglish} name="bio"></textarea>
                </InputContainer>
                <FileInput>
                  <label htmlFor="englishWorksFiles">Select Files</label>
                  <input
                    type="file"
                    name="files"
                    id="englishWorksFiles"
                    multiple
                    ref={registerEnglish({required: true})}
                    required
                  />
                  <span>
                    Note: Only files with .DOCX and .PDF will be accepted
                  </span>
                </FileInput>
                <button type="submit">Send Contribution</button>
              </ContributeForm>
            </ContributeSubmission>
          </ContributeBody>
        ) : null}
        {selected === FILIPINO ? (
          <ContributeBody
            key={FILIPINO}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 1 }}
          >
            <ContributeGuidelines>
              <h1>Mga Patnubay sa Pagsumite</h1>
              <p>{data.filipinoGuidelines.filipinoGuidelines}</p>
              <Link to={`/${data.filipinoArticle.slug}`}>Magbasa pa</Link>
            </ContributeGuidelines>
            <ContributeSubmission>
              <h1>Porma ng Pagsumite</h1>
              <ContributeForm onSubmit={handleSubmitFilipino(onFormSubmit('contribute-filipino'))}>
                <TwoInputColumn>
                  <input type="text" placeholder="Pangalan*" ref={registerFilipino({required: true})} required name="name"></input>
                  <input
                    type="text"
                    placeholder="Kurso & Taon / Departmento / Opisina**"
                    ref={registerFilipino({required: true})}
                    required
                    name="course"
                  ></input>
                </TwoInputColumn>
                <TwoInputColumn>
                  <input type="email" placeholder="Email Address*"  ref={registerFilipino({required: true})}
                    required
                    name="email"></input>
                  <input type="text" placeholder="Numero ng Telepono*"     ref={registerFilipino({required: true})}
                    required
                    name="contact"></input>
                </TwoInputColumn>
                <InputContainer>
                  <textarea placeholder="May-akda ng Bio / Bio-note, at Mga Tala sa Pamamaraan (opsyonal)"     ref={registerFilipino({required: true})}
                    required
                    name="bio"></textarea>
                </InputContainer>
                <FileInput>
                  <label htmlFor="filipinoWorksFiles">Select Files</label>
                  <input
                    type="file"
                    name="files"
                    id="filipinoWorksFiles"
                    multiple
                    ref={registerFilipino({required: true})}
                    required
                  />
                  <span>
                    Note: Only files with .DOCX and .PDF will be accepted
                  </span>
                </FileInput>
                <button type="submit">Send Contribution</button>
              </ContributeForm>
            </ContributeSubmission>
          </ContributeBody>
        ) : null}
        {selected === ARTWORK ? (
          <ContributeBody
            key={ARTWORK}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 1 }}
          >
            <ContributeGuidelines>
              <h1>Submission Guidelines</h1>
              <p>{data.artworkGuidelines.artworkGuidelines}</p>
              <Link to={`/${data.artworkArticle.slug}`}>Read More</Link>
            </ContributeGuidelines>
            <ContributeSubmission>
              <h1>Submission Form</h1>
              <ContributeForm onSubmit={handleSubmitArtwork(onFormSubmit('contribute-artwork'))}>
                <TwoInputColumn>
                  <input type="text" placeholder="Name*" ref={registerArtwork({required: true})} required name="name"></input>
                  <input
                    type="text"
                    placeholder="Course & Batch / Department / Office*"
                    ref={registerArtwork({required: true})} required name="course"
                  ></input>
                </TwoInputColumn>
                <TwoInputColumn>
                  <input type="email" placeholder="Email Address*" ref={registerArtwork({required: true})} required name="email"></input>
                  <input type="text" placeholder="Contact number*" ref={registerArtwork({required: true})} required name="contact"></input>
                </TwoInputColumn>
                <InputContainer>
                  <textarea placeholder="Author Bio / Bio-note, and Notes on Procedure (optional)" ref={registerArtwork({required: true})} required name="bio"></textarea>
                </InputContainer>
                <FileInput>
                  <label htmlFor="artworksFiles">Select Files</label>
                  <input type="file" name="files" id="artworksFiles" multiple ref={registerArtwork({required: true})} required/>
                  <span>
                    Note: Only files with .DOCX and .PDF will be accepted
                  </span>
                </FileInput>
                <button type="submit">Send Contribution</button>
              </ContributeForm>
            </ContributeSubmission>
          </ContributeBody>
        ) : null}
      </ContributeBodyWrapper>
    </ContributeSection>
  )
}

export default Contribute
